import { Fragment, useEffect } from 'react';
import { Navbar } from 'fileIndexing/otherComponents/Navbar';
import { NavigationMenu } from 'fileIndexing/otherComponents/NavigationMenu';

import { DataSourceTable } from '../components/dataSourceTable';

export function DataSourceMainPage () {
    useEffect(() => {
        document.title = 'File Indexing - Data Sources';
    }, []);

    return (
        <Fragment>
            <Navbar />
            <NavigationMenu />
            <DataSourceTable />
        </Fragment>
    );
}